import React, { useEffect } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Tooltip } from '@mui/material';
import { Checkbox } from 'primereact/checkbox';
import { PlayCircleFilled } from '@mui/icons-material';
import { toast } from 'react-toastify';
import {
  styledCheckboxHeader,
  styledColumnHeaderCheckbox
} from '../../../components/layout/main/mainStyles';
import { LoadingRowsComponent } from '../../../components/commons/LoadingRows/LoadingRows';
import { IScene } from '../../../types/Scenes/scenesTypes';
import { ContainerTable } from '../../locations/locationsList/locationListStyles';
import { maxCharactersString } from '../../../utils/commonUtils';
import Strings from '../../../i18n';
import { useExecuteSceneMutation } from '../../../services/scenes/sceneService';

interface IScenesListTemplateProps {
  selectedScenes: any[];
  setSelectedScenes: (selectedScenes: any[]) => void;
  scenes: IScene[];
  isLoading: boolean;
}
export const ScenesListTemplate = ({
  selectedScenes,
  setSelectedScenes,
  scenes,
  isLoading
}: IScenesListTemplateProps) => {
  const [execute, { isSuccess: isSuccessExecute }] = useExecuteSceneMutation();
  const getHeaderCheckbox = () => {
    return (
      <Checkbox
        className="p-checkbox"
        style={{
          visibility: selectedScenes.length > 0 ? 'visible' : 'hidden',
          ...styledCheckboxHeader
        }}
        checked={selectedScenes.length > 0 || false}
        onChange={() => {
          setSelectedScenes([]);
        }}
      />
    );
  };

  const getActionsColumn = (rowData: IScene) => {
    return (
      <div className="d-flex align-items-center my-1">
        <Tooltip title={Strings.scenes.executeThisScene}>
          <PlayCircleFilled
            data-testid="button"
            onClick={(e) => {
              e.stopPropagation();
              execute(rowData.id || 0);
            }}
            style={{ cursor: 'pointer', zIndex: 300 }}
          />
        </Tooltip>
      </div>
    );
  };

  useEffect(() => {
    if (isSuccessExecute) {
      toast.success(Strings.scenes.successExecuteScene);
    }
  }, [isSuccessExecute]);

  const getSummaryColumn = (rowData: IScene) => {
    const rawString = rowData?.summary || '';

    const listItems = rawString.split('\r\n');

    return (
      <ul>
        {listItems.map((item, index) => (
          <Tooltip title={item}>
            <li>{maxCharactersString(item, 40)}</li>
          </Tooltip>
        ))}
      </ul>
    );
  };

  return (
    <>
      {isLoading && <LoadingRowsComponent />}
      {!isLoading && scenes && (
        <ContainerTable component="main">
          <DataTable
            rowHover
            selection={selectedScenes}
            onSelectionChange={(e) => {
              console.log(e);
              setSelectedScenes(e.value);
            }}
            className="mt-3"
            value={scenes}
            size="small"
            scrollable
            scrollHeight="flex"
            paginator={scenes && scenes.length >= 50}
            selectionPageOnly
            rows={50}
            metaKeySelection
            rowsPerPageOptions={[5, 10, 20, 50, scenes ? scenes.length : 50]}
            tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
          >
            <Column selectionMode="multiple" frozen />
            <Column field="id" header="Id" sortable />
            <Column field="name" header="Name" sortable />
            <Column field="sceneIndex" header="Scene Index" sortable />
            <Column field="actionCount" header="Action Count" sortable />
            <Column
              field="summary"
              header="Summary"
              sortable
              body={getSummaryColumn}
            />
            <Column field="sceneTypeName" header="Type" sortable />
            <Column field="" header="Actions" body={getActionsColumn} />
          </DataTable>
        </ContainerTable>
      )}
    </>
  );
};
